var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1667 2.16667H14.6667C15.1269 2.16667 15.5 2.53977 15.5 3V18C15.5 18.4603 15.1269 18.8333 14.6667 18.8333H1.33333C0.8731 18.8333 0.5 18.4603 0.5 18V3C0.5 2.53977 0.8731 2.16667 1.33333 2.16667H3.83333V0.5H5.5V2.16667H10.5V0.5H12.1667V2.16667ZM12.1667 3.83333V5.5H10.5V3.83333H5.5V5.5H3.83333V3.83333H2.16667V17.1667H13.8333V3.83333H12.1667ZM3.83333 7.16667H12.1667V8.83333H3.83333V7.16667ZM3.83333 10.5H12.1667V12.1667H3.83333V10.5Z",
    fill: "#E60A2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.0237c5ce7630a9e6d25c47c9111c570e.svg";
export { ForwardRef as ReactComponent };